module.exports = __webpack_public_path__ + "img/fin_ill_1.f723ef58.png";